import { render, staticRenderFns } from "./Panel.vue?vue&type=template&id=6c19f80b&scoped=true&"
import script from "./Panel.vue?vue&type=script&lang=js&"
export * from "./Panel.vue?vue&type=script&lang=js&"
import style0 from "./Panel.vue?vue&type=style&index=0&id=6c19f80b&prod&scoped=true&lang=scss&"
import style1 from "./Panel.vue?vue&type=style&index=1&id=6c19f80b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c19f80b",
  null
  
)

export default component.exports